import {
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import { componentDestroyed } from 'ng2-rx-componentdestroyed';
import {
  share,
  takeUntil,
} from 'rxjs/operators';

import { CommonService } from '@services/common.service';
import { YTBSEOService } from '@services/ytb-seo.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-emailConfirmationCheck',
    templateUrl: './emailConfirmationCheck.component.html',
    providers: []
})
export class EmailConfirmationCheckComponent implements OnInit {
    isLoading: boolean = false;
    userNotFounfShowFail: boolean = false;
    userNotFoundShowSuccess: boolean = false;
    userNotFoundMessageInfo: any = {};
      private destroyRef = inject(DestroyRef);
    
    constructor(
        private commonService: CommonService, private route: ActivatedRoute, private router: Router,private ytbseo:YTBSEOService) { }

    ngOnInit() {
        this.route.queryParams.subscribe(res => {
            let urls = this.router.url.split("?");
            setTimeout(() => {
              this.ytbseo.createCanonicalURL(this.router.url);
              this.ytbseo.setDynamicTitle(urls[0]);
            }, 2000);
            
            if (res && Object.keys(res).length != 0) {
                this.isLoading = true;
                this.commonService.validateB2CUserEmail(res.userId);
            } else {
                  this.commonService.logError({
                logLevel: "Error page Navigation Before",
                message:
                  "Email Confirmation Check using query params From Email Confirmation Check Component "
              });
                this.router.navigate(["error"]);
            }

            // let url = this.router.url.split('?');
            // setTimeout(() => {
    
            //   this.ytbseo.createCanonicalURL(this.router.url);
            //   this.ytbseo.setDynamicTitle(url[0], { check:'Check' });
            //   this.ytbseo.updateMetaTags(
            //     'desc',
            //     { 'replaceKeywords': { 'check':'Check' } },
            //     'Homepage');
            // }, 1000);

        });

        this.commonService.VALIDATEUSEREMAILADDRESSSUCCESS.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            if (res) {
                this.userNotFounfShowFail = false;
                this.isLoading = false;
                this.userNotFoundMessageInfo = res.messageInfo;
                if (res.successCode) {
                    this.userNotFoundShowSuccess = true;
                } else {
                    this.userNotFounfShowFail = true;
                }
            }
        })
    }

    ngOnDestroy() {
        this.commonService.dispose();
    }
}